module.exports = __webpack_public_path__ + "img/mine_layer_factory_small.23df3b5b.png";